
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotissue",
      function () {
        return require("private-next-pages/hotissue/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotissue"])
      });
    }
  